import React, { useState, useEffect } from 'react'
import { Toast} from 'antd-mobile'
import {AddressBox, Content} from './style'
import { validPhone } from '@/utils'
import  bwmodel from '@/config/bwmodel'
import bridge from '@/config/JSbridge'
import Header from "@/components/Header";
import styles from '@/styles'
import {getActivityUserInfo, activityInfo, registerAddress } from '@/api/user-new'
const Address = () => {
  const [addr, setAddr] = useState({
    recipientName: '',
    recipientPhone: '',
    recipientAddress:''
  })
  const [isHasAddr, setIsHasAddr] = useState(false)
  const [name, setName] = useState('')
  const url = new URLSearchParams(window.location.search) // 获取url地址参数
  const  activityId= url.get('activity') // 得到的就是值
  const isStorm = bwmodel.app === 'storm';
  useEffect(()=> {
    activityInfo({id: activityId})
      .then(res => {
        setName(res.introduce)
      })

    getActivityUserInfo(activityId)
      .then(res => {
        if(res.recipientAddress) {
          setAddr(res.recipientAddress)
          setIsHasAddr(true)
        } else {

        }
      })
      .catch(error => {
        let res = error.response
        if (res && res.status === 401) {
          Toast.info('请先登录')
        }
      })
  },[])
  function handleSubmit () {
    
    if(!addr.recipientName) {
      return Toast.info('输入的收货人不能为空')
     } else  if(!addr.recipientPhone) {
      return  Toast.info('输入的手机号不能为空')
     }else  if(!addr.recipientAddress) {
      return Toast.info('输入的收货地址不能为空')
     }

     if (!validPhone(addr.recipientPhone)) {
      Toast.info('请输入正确手机号');
      return;
    }

    registerAddress({
      recipientName: addr.recipientName,
      recipientPhone: addr.recipientPhone,
      recipientAddress: addr.recipientAddress,
      activityId: activityId
    }).then(res => {
      Toast.info('收货信息提交成功')
      setTimeout(()=> {
        bridge.callHandler('nativeEvent', {event: 'close', params: {
          isDelete: false
        }}, () => {})
      },2000)
     
    })
    .catch(error => {
      let res = error.response
      if (res && res.status === 401) {
        // setIsLogin(false);
        Toast.info('请先登录')
      }
    })
  }
  return (
    <AddressBox style={isStorm ? {paddingTop:54} :{}} className={bwmodel.theme==='1'?'theme1':''}>
   {/* <div className="delivery-title"></div> */}

   {isStorm && 
      <Header
        title="填写收货地址"
        hideNaviBar
        bg_color={styles.bg_color2}
      />
    }
          <Content className={bwmodel.theme==='1'?'theme1':''}>
   
          <div>
              <div className='input_item'>
                <div>活动名称</div>
                {/* <div style={{flex:1}}>{name}</div> */}
                <input type="text" maxLength={20} value={name}  placeholder="请输入活动名称(必填)" disabled></input>
              </div>
              <div className='input_item bt'>
                <div>收货人<span>*</span></div>
                <input type="text" maxLength={20} value={addr.recipientName} onChange={e => setAddr({...addr,recipientName:e.target.value})}   placeholder="请输入收货人姓名(必填)"></input>
              </div>
              <div className='input_item bt'>
                <div>手机号<span>*</span></div>
                <input type="tel" maxLength={11} value={addr.recipientPhone} onChange={e => setAddr({...addr,recipientPhone:e.target.value})}  placeholder="请输入手机号(必填)"></input>
              </div>
              <div className='input_item '>
                <div>收货地址<span>*</span></div>
                <textarea  rows="3" value={addr.recipientAddress} maxLength={200} onChange={e => setAddr({...addr,recipientAddress:e.target.value})}  placeholder="请输入收货地址， 需详细输入到省/市/区/街道/小区（必填）"></textarea>
              </div>
            </div>
          </Content>
        <div className='footer'>
          <div className="delivery-tip">*以上信息我们将加密保存，请放心填写</div>
          <div onClick={handleSubmit} className="delivery-btn">{isHasAddr?'确认修改':'确认提交'}</div>
        </div>
    </AddressBox>
  )
}

export default Address;


// WEBPACK FOOTER //
// ./src/views/address/index.js